<template>
	<div class="about-us-mobile" v-if="isMobile">
		<img src="../assets/img/ppjs.png" class="img-banner">
		<div class="main-content">
			<div class="row-me tab-div">
				<div class="column-me center-all left-div">
					<div class="title1">品牌介绍</div>
					<div class="title2">ABOUT US</div>
				</div>
				<div class="row-me row-center flex-wrap flex1">
					<div class="title0" :class="{'title0-active':tabIndex===0}" @click="clickIndex(0)">品牌介绍</div>
					<div class="tab-line"></div>
					<div class="title0" :class="{'title0-active':tabIndex===1}" @click="clickIndex(1)">资质荣誉</div>
					<!-- <div class="tab-line"></div> -->
					<div class="title0" :class="{'title0-active':tabIndex===2}" @click="clickIndex(2)">门店展示</div>
					<div class="tab-line"></div>
					<div class="title0" :class="{'title0-active':tabIndex===3}" @click="clickIndex(3)">新闻动态</div>
				</div>
			</div>
			<!-- 品牌介绍 -->
			<div class="column-me row-center" v-if="tabIndex===0">
				<div class="row-me center-all margin-top50">
					<img src="../assets/img/title_line.png" class="img-line">
					<div class="column-me row-center margin-left10 margin-right10">
						<div class="title">品牌发展</div>
					</div>
					<img src="../assets/img/title_line.png" class="img-line">
				</div>
				<div class="subtitle">BRAND DEVELOPMENT</div>
				<div class="column-me row-center width100Per margin-top80">
					<div class="black-div anim-bigger-small">
						<div class="title-black">
							&emsp;&emsp;红尾狐（国际）儿童卡丁车俱乐部致力于儿童卡丁车的研发、生产、培训、运营、推广，并以儿童卡丁车为平台，植入训练课程、赛事组织、研学拓展等内容，打造一个开放、共享的全球连锁儿童娱乐竞技化产业平台。
							<br>
							&emsp;&emsp;红尾狐卡丁通过打造性价比极高的卡丁车儿童室内训练场，使此项运动成本急剧降低，多种赛场元素的真实还原，让训练场馆极具视觉冲击力，给予小朋友沉浸式的驾驶体验。同步推进的训练课程，从体能、智能、技能多个方面实现孩子能力的提升，培养孩子的应变能力、动手能力、抗挫能力和团队意识，让孩子更专注、更开朗、更自信。
						</div>
					</div>
					<img src="../assets/img/img1.png" class="img-develop">
				</div>
				<div class="row-me center-all margin-top60">
					<img src="../assets/img/title_line.png" class="img-line">
					<div class="column-me row-center margin-left10 margin-right10">
						<div class="title">品牌文化</div>
					</div>
					<img src="../assets/img/title_line.png" class="img-line">
				</div>
				<div class="subtitle">BRAND CULTURE</div>
				<div class="column-me row-center width100Per flex-sb margin-top50">
					<div class="card-div posRelative">
						<div @mouseenter="cultureIndex=0">
							<img src="../assets/img/img2.png" class="width100Per height100Per objFitCover">
							<div class="column-me center-all yellow-mask posAbsoluteAll">
								<div class="title1">品牌定位</div>
								<div class="title2">BRAND POSITIONING</div>
							</div>
						</div>
						<transition name="el-zoom-in-bottom">
							<div class="column-me show-div posAbsoluteAll" v-if="cultureIndex===0"
								@mouseleave="cultureIndex=-1">
								<img src="../assets/img/img2.png" class="img2">
								<div class="black1 column-me flex1">
									<div class="title11">品牌定位</div>
									<div class="title22">面向3-12岁儿童开展卡丁车培训、赛事<br>组织并延伸至青少年卡丁车运动</div>
								</div>
							</div>
						</transition>
					</div>
					<div class="card-div posRelative margin-top20">
						<div @mouseenter="cultureIndex=1">
							<img src="../assets/img/img3.png" class="width100Per height100Per objFitCover">
							<div class="column-me center-all yellow-mask posAbsoluteAll">
								<div class="title1">品牌理念</div>
								<div class="title2">BRAND CONCEPT</div>
							</div>
						</div>
						<transition name="el-zoom-in-bottom">
							<div class="column-me show-div posAbsoluteAll" v-if="cultureIndex===1"
								@mouseleave="cultureIndex=-1">
								<img src="../assets/img/img3.png" class="img2">
								<div class="black1 column-me flex1">
									<div class="title11">品牌理念</div>
									<div class="title22">打造共享的全球连锁儿童卡丁车竞技产业平台，<br>圆孩子赛车手的梦想</div>
								</div>
							</div>
						</transition>
					</div>
				</div>
			</div>
			<!-- 资质荣誉 -->
			<div class="column-me row-center" v-if="tabIndex===1">
				<div class="row-me center-all margin-top60">
					<img src="../assets/img/title_line.png" class="img-line">
					<div class="column-me row-center margin-left10 margin-right10">
						<div class="title">资质荣誉</div>
					</div>
					<img src="../assets/img/title_line.png" class="img-line">
				</div>
				<div class="subtitle">QUALIFICATION HONOR</div>
				<div class="row-me margin-top80">
					<waterfalls :columns="1" :data="dataArray" :space="0">
						<template v-slot:fallItem="scope">
							<div class="column-me item-card" @click="clickHonor(scope.item)">
								<el-image :src="scope.item.logo" fit="cover" class="img-card">
									<template #error>
										<img src="../assets/img/default.png" slot="error"
											class="width100Per height100Per objFitCover">
									</template>
								</el-image>
								<div class="title1 line1" v-if="scope.item.name">{{scope.item.name}}</div>
								<div class="title2" v-if="scope.item.create_time">{{scope.item.create_time}}</div>
								<div class="title3 line2" v-html="scope.item.content" v-if="scope.item.content"></div>
							</div>
						</template>
					</waterfalls>
				</div>
			</div>
			<!-- 门店展示 -->
			<div class="column-me row-center" v-if="tabIndex===2">
				<div class="row-me center-all margin-top60">
					<img src="../assets/img/title_line.png" class="img-line">
					<div class="column-me row-center margin-left10 margin-right10">
						<div class="title">门店展示</div>
					</div>
					<img src="../assets/img/title_line.png" class="img-line">
				</div>
				<div class="subtitle">SHOP DISPLAY</div>
				<div class="column-me row-center margin-top50 flex-wrap">
					<div class="item-show row-me row-center" v-for="(item,index) in storeArray" :key="index"
						@click="clickStore(item)">
						<el-image :src="item.img" fit="cover" class="item-img img-round">
							<template #error>
								<img src="../assets/img/default.png" slot="error"
									class="width100Per height100Per objFitCover">
							</template>
						</el-image>
						<div class="column-me margin-left30 flex1">
							<div class="title1">{{item.name}}</div>
							<div class="title2">{{item.address}}</div>
						</div>
						<div class="height100Per">
							<div class="look-div">查看</div>
						</div>
					</div>
				</div>
				<div class="row-me center-all margin-top50">
					<el-pagination background layout="prev, pager, next" :total="storeTotal" :page-size="limitStore"
						@current-change="storePageChange">
					</el-pagination>
				</div>
				<div class="row-me center-all margin-top100">
					<div class="column-me row-center margin-left60 margin-right60">
						<div class="title">门店视频</div>
						<div class="subtitle">SHOP VIDEO</div>
					</div>
				</div>
				<div class="column-me center-all margin-top50 flex-wrap width100Per">
					<div class="item-video" v-for="(item,index) in videoArray" :key="index">
						<video :src="item.video" class="video" controls :poster="item.img"></video>
					</div>
				</div>
				<img src="../assets/img/more2.png" class="img-more anim-bigger-small"
					v-if="videoArray.length<videoTotal" @click="clickMoreVideo">
				<div class="row-me center-all margin-top100">
					<div class="column-me row-center margin-left60 margin-right60">
						<div class="title">门店图册</div>
						<div class="subtitle">SHOP IMAGE</div>
					</div>
				</div>
				<div class="margin-top50">
					<waterfalls :columns="2" :data="imageArray" :space="30">
						<template v-slot:fallItem="scope">
							<el-image :src="scope.item.img" :preview-src-list="[scope.item.img]" class="img-shop"
								fit="fill" hide-on-click-modal>
								<template #error>
									<img src="../assets/img/default.png" slot="error"
										class="width100Per height100Per objFitCover">
								</template>
							</el-image>
						</template>
					</waterfalls>
				</div>
				<img src="../assets/img/more2.png" class="img-more anim-bigger-small margin-bottom50"
					v-if="imageArray.length<imageTotal" @click="clickMoreImage">
			</div>
			<!-- 新闻动态 -->
			<div class="column-me row-center" v-if="tabIndex===3">
				<div class="row-me center-all margin-top90">
					<img src="../assets/img/title_line.png" class="img-line">
					<div class="column-me row-center margin-left10 margin-right10">
						<div class="title">新闻动态</div>
					</div>
					<img src="../assets/img/title_line.png" class="img-line">
				</div>
				<div class="subtitle">NEWS</div>
				<div class="margin-top50 width100Per">
					<div class="item-news row-me row-center" v-for="(item,index) in newsArray" :key="index"
						@click="clickNews(item)">
						<el-image :src="item.cover" class="img-news" fit="cover">
							<template #error>
								<img src="../assets/img/default.png" slot="error"
									class="width100Per height100Per objFitCover">
							</template>
						</el-image>
						<div class="column-me height100Per flex1 margin-left10 margin-right10">
							<div class="news-title line1">
								{{item.title}}
							</div>
							<div class="news-date">{{item.create_time}}</div>
							<div class="news-content line3 margin-top10" v-html="item.content"></div>
						</div>
					</div>
				</div>
				<div class="row-me center-all margin-top50 margin-bottom30">
					<el-pagination background layout="prev, pager, next" :total="newsTotal" :page-size="limitNews"
						@current-change="newsPageChange">
					</el-pagination>
				</div>
			</div>
		</div>
		<!-- 门店地址弹窗 -->
		<el-dialog :title="selectStore.name" v-model="dialogStoreVisible" width="90%">
			<div class="map-div" id="container"></div>
		</el-dialog>
	</div>
	<div class="about-us" v-else>
		<img src="../assets/img/ppjs.png" class="img-banner">
		<div class="main-content">
			<div class="row-me row-center tab-div">
				<div class="row-me center-all left-div">
					<div class="title1">品牌介绍</div>
					<div class="title2 margin-left20">ABOUT US</div>
				</div>
				<div class="row-me row-center flex-end flex1 padding-right30">
					<div class="title0" :class="{'title0-active':tabIndex===0}" @click="clickIndex(0)">品牌介绍</div>
					<div class="tab-line"></div>
					<div class="title0" :class="{'title0-active':tabIndex===1}" @click="clickIndex(1)">资质荣誉</div>
					<div class="tab-line"></div>
					<div class="title0" :class="{'title0-active':tabIndex===2}" @click="clickIndex(2)">门店展示</div>
					<div class="tab-line"></div>
					<div class="title0" :class="{'title0-active':tabIndex===3}" @click="clickIndex(3)">新闻动态</div>
				</div>
			</div>
			<!-- 品牌介绍 -->
			<div class="column-me row-center" v-if="tabIndex===0">
				<div class="row-me center-all margin-top90">
					<img src="../assets/img/title_line.png" class="img-line">
					<div class="column-me row-center margin-left60 margin-right60">
						<div class="title">品牌发展</div>
						<div class="subtitle">BRAND DEVELOPMENT</div>
					</div>
					<img src="../assets/img/title_line.png" class="img-line">
				</div>
				<div class="row-me row-center width100Per margin-top80">
					<div class="black-div anim-bigger-small">
						<div class="title-black">
							&emsp;&emsp;红尾狐（国际）儿童卡丁车俱乐部致力于儿童卡丁车的研发、生产、培训、运营、推广，并以儿童卡丁车为平台，植入训练课程、赛事组织、研学拓展等内容，打造一个开放、共享的全球连锁儿童娱乐竞技化产业平台。
							<br>
							&emsp;&emsp;红尾狐卡丁通过打造性价比极高的卡丁车儿童室内训练场，使此项运动成本急剧降低，多种赛场元素的真实还原，让训练场馆极具视觉冲击力，给予小朋友沉浸式的驾驶体验。同步推进的训练课程，从体能、智能、技能多个方面实现孩子能力的提升，培养孩子的应变能力、动手能力、抗挫能力和团队意识，让孩子更专注、更开朗、更自信。
						</div>
					</div>
					<img src="../assets/img/img1.png" class="img-develop">
				</div>
				<div class="row-me center-all margin-top130">
					<img src="../assets/img/title_line.png" class="img-line">
					<div class="column-me row-center margin-left60 margin-right60">
						<div class="title">品牌文化</div>
						<div class="subtitle">BRAND CULTURE</div>
					</div>
					<img src="../assets/img/title_line.png" class="img-line">
				</div>
				<div class="row-me row-center flex-sb margin-top80">
					<div class="card-div posRelative">
						<div @mouseenter="cultureIndex=0">
							<img src="../assets/img/img2.png" class="width100Per height100Per objFitCover">
							<div class="column-me center-all yellow-mask posAbsoluteAll">
								<div class="title1">品牌定位</div>
								<div class="title2">BRAND POSITIONING</div>
							</div>
						</div>
						<transition name="el-zoom-in-bottom">
							<div class="column-me show-div posAbsoluteAll" v-if="cultureIndex===0"
								@mouseleave="cultureIndex=-1">
								<img src="../assets/img/img2.png" class="img2">
								<div class="black1 column-me flex1">
									<div class="title11">品牌定位</div>
									<div class="title22">面向3-12岁儿童开展卡丁车培训、赛事<br>组织并延伸至青少年卡丁车运动</div>
								</div>
							</div>
						</transition>
					</div>
					<div class="card-div posRelative margin-left40">
						<div @mouseenter="cultureIndex=1">
							<img src="../assets/img/img3.png" class="width100Per height100Per objFitCover">
							<div class="column-me center-all yellow-mask posAbsoluteAll">
								<div class="title1">品牌理念</div>
								<div class="title2">BRAND CONCEPT</div>
							</div>
						</div>
						<transition name="el-zoom-in-bottom">
							<div class="column-me show-div posAbsoluteAll" v-if="cultureIndex===1"
								@mouseleave="cultureIndex=-1">
								<img src="../assets/img/img3.png" class="img2">
								<div class="black1 column-me flex1">
									<div class="title11">品牌理念</div>
									<div class="title22">打造共享的全球连锁儿童卡丁车竞技产业平台，<br>圆孩子赛车手的梦想</div>
								</div>
							</div>
						</transition>
					</div>
				</div>
			</div>
			<!-- 资质荣誉 -->
			<div class="column-me row-center" v-if="tabIndex===1">
				<div class="row-me center-all margin-top90">
					<img src="../assets/img/title_line.png" class="img-line">
					<div class="column-me row-center margin-left60 margin-right60">
						<div class="title">资质荣誉</div>
						<div class="subtitle">QUALIFICATION HONOR</div>
					</div>
					<img src="../assets/img/title_line.png" class="img-line">
				</div>
				<div class="row-me margin-top80">
					<waterfalls :columns="3" :data="dataArray" :space="30">
						<template v-slot:fallItem="scope">
							<div class="column-me item-card" @click="clickHonor(scope.item)">
								<el-image :src="scope.item.logo" fit="cover" class="img-card">
									<template #error>
										<img src="../assets/img/default.png" slot="error"
											class="width100Per height100Per objFitCover">
									</template>
								</el-image>
								<div class="title1 line1" v-if="scope.item.name">{{scope.item.name}}</div>
								<div class="title2" v-if="scope.item.create_time">{{scope.item.create_time}}</div>
								<div class="title3 line2" v-html="scope.item.content" v-if="scope.item.content"></div>
							</div>
						</template>
					</waterfalls>
				</div>
			</div>
			<!-- 门店展示 -->
			<div class="column-me row-center" v-if="tabIndex===2">
				<div class="row-me center-all margin-top90">
					<img src="../assets/img/title_line.png" class="img-line">
					<div class="column-me row-center margin-left60 margin-right60">
						<div class="title">门店展示</div>
						<div class="subtitle">SHOP DISPLAY</div>
					</div>
					<img src="../assets/img/title_line.png" class="img-line">
				</div>
				<div class="row-me row-center margin-top80 flex-wrap">
					<div class="item-show row-me row-center" v-for="(item,index) in storeArray" :key="index"
						@click="clickStore(item)">
						<el-image :src="item.img" fit="cover" class="width100 height100 img-round margin-left30">
							<template #error>
								<img src="../assets/img/default.png" slot="error"
									class="width100Per height100Per objFitCover">
							</template>
						</el-image>
						<div class="column-me margin-left30 flex1">
							<div class="title1">{{item.name}}</div>
							<div class="title2">{{item.address}}</div>
						</div>
						<div class="height100Per">
							<div class="look-div">查看</div>
						</div>
					</div>
				</div>
				<div class="row-me center-all margin-top80">
					<el-pagination background layout="prev, pager, next" :total="storeTotal" :page-size="limitStore"
						@current-change="storePageChange">
					</el-pagination>
				</div>
				<div class="row-me center-all margin-top100">
					<div class="column-me row-center margin-left60 margin-right60">
						<div class="title">门店视频</div>
						<div class="subtitle">SHOP VIDEO</div>
					</div>
				</div>
				<div class="row-me center-all margin-top80 flex-wrap">
					<div class="item-video" v-for="(item,index) in videoArray" :key="index">
						<video :src="item.video" class="video" controls :poster="item.img"></video>
					</div>
				</div>
				<img src="../assets/img/more2.png" class="img-more anim-bigger-small"
					v-if="videoArray.length<videoTotal" @click="clickMoreVideo">
				<div class="row-me center-all margin-top100">
					<div class="column-me row-center margin-left60 margin-right60">
						<div class="title">门店图册</div>
						<div class="subtitle">SHOP IMAGE</div>
					</div>
				</div>
				<div class="margin-top70">
					<waterfalls :columns="4" :data="imageArray" :space="30">
						<template v-slot:fallItem="scope">
							<el-image :src="scope.item.img" :preview-src-list="[scope.item.img]" class="img-shop"
								fit="fill" hide-on-click-modal>
								<template #error>
									<img src="../assets/img/default.png" slot="error"
										class="width100Per height100Per objFitCover">
								</template>
							</el-image>
						</template>
					</waterfalls>
				</div>
				<img src="../assets/img/more2.png" class="img-more anim-bigger-small margin-bottom50"
					v-if="imageArray.length<imageTotal" @click="clickMoreImage">
			</div>
			<!-- 新闻动态 -->
			<div class="column-me row-center" v-if="tabIndex===3">
				<div class="row-me center-all margin-top90">
					<img src="../assets/img/title_line.png" class="img-line">
					<div class="column-me row-center margin-left60 margin-right60">
						<div class="title">新闻动态</div>
						<div class="subtitle">NEWS</div>
					</div>
					<img src="../assets/img/title_line.png" class="img-line">
				</div>
				<div class="margin-top50 width100Per">
					<div class="item-news row-me row-center" v-for="(item,index) in newsArray" :key="index"
						@click="clickNews(item)">
						<el-image :src="item.cover" class="img-news" fit="cover">
							<template #error>
								<img src="../assets/img/default.png" slot="error"
									class="width100Per height100Per objFitCover">
							</template>
						</el-image>
						<div class="column-me height100Per flex1 margin-left50 margin-right50">
							<div class="row-me row-center flex-sb margin-top40">
								<div class="news-title flex1 margin-right50 line1">
									{{item.title}}
								</div>
								<div class="news-date">{{item.create_time}}</div>
							</div>
							<div class="news-content line3 margin-top30" v-html="item.content"></div>
						</div>
					</div>
				</div>
				<div class="row-me center-all margin-top80">
					<el-pagination background layout="prev, pager, next" :total="newsTotal" :page-size="limitNews"
						@current-change="newsPageChange">
					</el-pagination>
				</div>
			</div>
		</div>
		<!-- 门店地址弹窗 -->
		<el-dialog :title="selectStore.name" v-model="dialogStoreVisible">
			<div class="map-div" id="container"></div>
		</el-dialog>
	</div>
</template>

<script>
	import waterfalls from '../components/waterfalls.vue'
	export default {
		components: {
			waterfalls
		},
		data() {
			return {
				tabIndex: 0,
				dataArray: [], //资质荣誉
				cultureIndex: -1,
				storeArray: [], //门店数组
				storeTotal: 0, //总条数
				imageArray: [], //门店相册
				imageTotal: 0, //总条数
				videoArray: [], //门店视频
				videoTotal: 0, //总条数
				pageStore: 1,
				pageImage: 1,
				pageVideo: 1,
				limitStore: 12,
				limitImage: 8,
				limitVideo: 4,
				dialogStoreVisible: false,
				selectStore: {}, //点击的门店
				newsArray: [], //新闻数组
				newsTotal: 0, //总条数
				pageNews: 1,
				limitNews: 5,
				isMobile: false,
			}
		},
		// html加载完成之前
		created() {

		},
		// html加载完成后执行。
		mounted() {
			this.isMobile = sessionStorage.getItem('mobile') === '1'
		},
		// 事件方法执行
		methods: {
			clickIndex(index) {
				this.$router.push({
					path: '/about_us',
					query: {
						index: index
					}
				})
			},
			//新闻点击
			clickNews(item) {
				this.$router.push({
					path: '/detail',
					query: {
						id: item.id
					}
				})
			},
			//资质荣誉点击
			clickHonor(item) {
				this.$router.push({
					path: '/detail_honor',
					query: {
						id: item.id
					}
				})
			},
			//门店点击
			clickStore(item) {
				let that = this
				this.selectStore = item
				this.dialogStoreVisible = true
				this.$nextTick(() => {
					if (this.isIos()) {
						this.initStoreMapIos(item)
					} else {
						this.initStoreMap(item)
					}
				})
			},
			//更多视频
			clickMoreVideo() {
				this.pageVideo++
				this.getVideoList()
			},
			//更多图片
			clickMoreImage() {
				this.pageImage++
				this.getPhotos()
			},
			//门店页码改变
			storePageChange(val) {
				this.pageStore = val
				this.getShops()
				document.getElementById('content').scrollTop = 600
			},
			//新闻页码改变
			newsPageChange(val) {
				this.pageNews = val
				this.getNews()
				document.getElementById('content').scrollTop = 600
			},
			//获取资质荣誉
			getHonor() {
				this.$postRequest('/api/index/getHonor', {}).then((res) => {
					if (res) {
						this.dataArray = res.data
					}
				}).catch((error) => {
					console.log(error)
				})
			},
			//获取店铺列表
			getShops() {
				this.$postRequest('/api/index/getShops', {
					page: this.pageStore,
					limit: this.limitStore
				}).then((res) => {
					if (res) {
						this.storeTotal = res.data.total
						this.storeArray = res.data.data
					}
				}).catch((error) => {
					console.log(error)
				})
			},
			//获取店铺视频
			getVideoList() {
				this.$postRequest('/api/index/getVideoList', {
					page: this.pageVideo,
					limit: this.limitVideo
				}).then((res) => {
					if (res) {
						this.videoTotal = res.data.total
						if (this.pageVideo === 1) {
							this.videoArray = res.data.data
						} else {
							this.videoArray = this.videoArray.concat(res.data.data)
						}
					}
				}).catch((error) => {
					console.log(error)
				})
			},
			//获取店铺相册
			getPhotos() {
				this.$postRequest('/api/index/getPhotos', {
					page: this.pageImage,
					limit: this.limitImage
				}).then((res) => {
					if (res) {
						this.imageTotal = res.data.total
						if (this.pageImage === 1) {
							this.imageArray = res.data.data
						} else {
							this.imageArray = this.imageArray.concat(res.data.data)
						}
					}
				}).catch((error) => {
					console.log(error)
				})
			},
			//初始化门店地图
			initStoreMap(item) {
				const AMap = window.AMap
				if (!AMap) {
					return
				}
				var map = new AMap.Map('container', {
					resizeEnable: true,
					center: [Number(item.longitude), Number(item.latitude)],
					zoom: 17,
					viewMode: '3D' //使用3D视图
				});
				var marker = new AMap.Marker({
					position: [Number(item.longitude), Number(item.latitude)], //位置
					title: item.name,
					icon: require('../assets/img/position.png'),
					offset: new AMap.Pixel(-30, -40)
				})
				map.add(marker); //添加到地图
				let content =
					'<div class="map-info-window-content row-me center-all">' +
					'<div class="map-company-name">' + item.name + '</div>' +
					'</div>';
				if (this.isMobile) {
					var infoWindow = new AMap.InfoWindow({
						isCustom: true, //使用自定义窗体
						showShadow: true,
						content: content,
						offset: new AMap.Pixel(-10, 120)
					});
					infoWindow.open(map, marker.getPosition());
				} else {
					var infoWindow = new AMap.InfoWindow({
						isCustom: true, //使用自定义窗体
						showShadow: true,
						content: content,
						offset: new AMap.Pixel(-10, 60)
					});
					infoWindow.open(map, marker.getPosition());
				}
			},
			initStoreMapIos(item) {
				const AMap = window.AMap
				if (!AMap) {
					return
				}
				var map = new AMap.Map('container', {
					resizeEnable: true,
					center: [Number(item.longitude), Number(item.latitude)],
					zoom: 19,
					viewMode: '3D' //使用3D视图
				});
				var marker = new AMap.Marker({
					position: [Number(item.longitude), Number(item.latitude)], //位置
					title: item.name,
					icon: new AMap.Icon({
						image: require('../assets/img/position.png'),
						size: new AMap.Size(170, 170), //图标所处区域大小
						imageSize: new AMap.Size(170, 170) //图标大小
					}),
					offset: new AMap.Pixel(-100, -200)
				})
				map.add(marker); //添加到地图
				let content =
					'<div class="map-info-window-content row-me center-all">' +
					'<div class="map-company-name">' + item.name + '</div>' +
					'</div>';
				if (this.isMobile) {
					var infoWindow = new AMap.InfoWindow({
						isCustom: true, //使用自定义窗体
						showShadow: true,
						content: content,
						offset: new AMap.Pixel(-10, 350)
					});
					infoWindow.open(map, marker.getPosition());
				} else {
					var infoWindow = new AMap.InfoWindow({
						isCustom: true, //使用自定义窗体
						showShadow: true,
						content: content,
						offset: new AMap.Pixel(-10, 60)
					});
					infoWindow.open(map, marker.getPosition());
				}
			},
			//是否苹果手机
			isIos() {
				let ua = navigator.userAgent.toLowerCase()
				return ua.indexOf('iphone') !== -1
			},
			//获取新闻列表
			getNews() {
				this.$postRequest('/api/index/getNews', {
					page: this.pageNews,
					limit: this.limitNews
				}).then((res) => {
					if (res) {
						this.newsTotal = res.data.total
						this.newsArray = res.data.data
					}
				}).catch((error) => {
					console.log(error)
				})
			},
		},
		// 计算属性
		computed: {},
		// 侦听器
		watch: {
			$route: {
				handler(to, from) {
					if (to.name.indexOf('about_us') !== -1) {
						if (this.$route.query.index) {
							this.tabIndex = Number(this.$route.query.index)
						}
					}
				},
				deep: true
			},
			tabIndex(newVal, oldVal) {
				if (this.tabIndex === 1) {
					this.getHonor()
				} else if (this.tabIndex === 2) {
					this.getShops()
					this.getVideoList()
					this.getPhotos()
				} else if (this.tabIndex === 3) {
					this.getNews()
				}
			}
		},
		activated() {
			if (this.$route.query.index) {
				this.tabIndex = Number(this.$route.query.index)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.about-us-mobile {
		.img-banner {
			width: 100%;
			object-fit: cover;
			pointer-events: none;
		}

		.main-content {
			padding: 20px;

			.tab-div {
				background: #F4F4F4;
				border-radius: 10px;

				.left-div {
					width: 130px;
					background: #000000;
					border-radius: 10px 0px 0px 10px;
					padding: 10px 0;

					.title1 {
						font-size: 23px;
						color: #FFFFFF;
					}

					.title2 {
						font-size: 15px;
						color: #FFF10C;
						margin-top: 10px;
					}
				}

				.title0 {
					font-size: 20px;
					color: #999999;
					text-align: center;
					padding: 0 10px;
					cursor: pointer;

					&:hover {
						font-weight: bold;
					}

					&-active {
						color: #666666;
						font-weight: bold;
					}
				}

				.tab-line {
					width: 3px;
					height: 20px;
					background: #999999;
					border-radius: 10px;
				}
			}

			.img-line {
				width: 80px;
			}

			.title {
				font-size: 28px;
				color: #000000;
				letter-spacing: 2px;
				margin-bottom: 10px;
			}

			.subtitle {
				font-size: 18px;
				color: #666666;
			}

			.img-develop {
				width: 100%;
				height: 250px;
				margin-top: 20px;
				object-fit: cover;
			}

			.card-div {
				width: 100%;
				height: 400px;
				border-radius: 20px;
				overflow: hidden;
				cursor: pointer;

				.yellow-mask {
					background: RGBA(251, 225, 12, 0.8);

					.title1 {
						font-size: 35px;
						font-weight: bold;
						color: #000000;
					}

					.title2 {
						font-size: 20px;
						color: #000000;
						margin-top: 20px;
					}
				}

				.show-div {
					.img2 {
						width: 100%;
						height: 220px;
						object-fit: cover;
					}

					.black1 {
						background-color: #000000;

						.title11 {
							font-size: 25px;
							color: #FFFFFF;
							margin-left: 25px;
							margin-top: 20px;
						}

						.title22 {
							font-size: 20px;
							color: #FFFFFF;
							margin-left: 25px;
							margin-right: 20px;
							margin-top: 20px;
							font-weight: 300;
						}
					}
				}
			}

			.black-div {
				background: #000000;
				overflow: auto;
				z-index: 100;

				.title-black {
					margin: 10px;
					font-size: 20px;
					color: #FFFFFF;
					line-height: 30px;
					font-weight: 300;
				}
			}

			.item-card {
				box-shadow: 0px 10px 30px 0px rgba(40, 40, 40, 0.3);
				cursor: pointer;
				margin-bottom: 30px;

				&:hover {
					background-color: #FADA0F;
				}

				.img-card {
					width: 100%;
					height: auto;
					object-fit: fill;
				}

				.title1 {
					font-size: 25px;
					color: #222222;
					font-weight: bold;
					margin: 20px 20px 0 20px;
				}

				.title2 {
					font-size: 20px;
					color: #222222;
					margin: 10px 20px 0 20px;
				}

				.title3 {
					font-size: 20px;
					color: #222222;
					margin: 10px 20px 20px 20px;
				}
			}
		}

		.item-show {
			width: 100%;
			padding: 10px 0;
			background: #F6F6F6;
			margin-bottom: 20px;
			cursor: pointer;

			&:hover {
				background: #FFE100;

				.look-div {
					background-color: #000000;
					color: #FFFFFF;
				}
			}

			&:nth-child(2n) {
				margin-right: 0;
			}

			.item-img {
				width: 60px;
				height: 60px;
				margin-left: 10px;
			}

			.title1 {
				font-size: 22px;
				color: #000000;
				font-weight: bold;
			}

			.title2 {
				font-size: 18px;
				color: #000000;
				margin-top: 10px;
			}

			.look-div {
				width: 60px;
				height: 30px;
				background: #FFE100;
				line-height: 30px;
				text-align: center;
				font-size: 18px;
				color: #000000;
				margin-right: 10px;
			}
		}

		.item-video {
			width: 100%;
			height: 250px;
			margin-bottom: 15px;

			&:nth-child(2n) {
				margin-right: 0;
			}

			.video {
				width: 100%;
				height: 100%;
				object-fit: fill;
			}
		}

		.img-more {
			width: 140px;
			height: 35px;
			margin-top: 50px;
			cursor: pointer;
		}

		.img-shop {
			width: 100%;
			background-color: lightblue;
			object-fit: fill;
		}

		.item-news {
			width: 100%;
			height: 120px;
			background: #FFFFFF;
			box-shadow: 0px 10px 30px 0px rgba(40, 40, 40, 0.1);
			cursor: pointer;
			margin-bottom: 20px;

			&:hover {
				background: #FADA0F;
			}

			.img-news {
				width: 150px;
				height: 100%;
				object-fit: cover;
			}

			.news-title {
				font-size: 15px;
				font-weight: bold;
				color: #222222;
				margin-top: 10px;
			}

			.news-date {
				font-size: 13px;
				color: #222222;
			}

			.news-content {
				font-size: 15px;
				color: #222222;
			}
		}

		.map-div {
			width: 100%;
			height: 50vh;
		}
	}

	.about-us {
		.img-banner {
			width: 100%;
			object-fit: cover;
			pointer-events: none;
		}

		.main-content {
			padding: 80px 100px;

			.tab-div {
				height: 100px;
				background: #F4F4F4;
				border-radius: 10px;

				.left-div {
					width: 330px;
					height: 100px;
					background: #000000;
					border-radius: 10px 0px 0px 10px;

					.title1 {
						font-size: 30px;
						color: #FFFFFF;
					}

					.title2 {
						font-size: 18px;
						color: #FFF10C;
						margin-bottom: -15px;
					}
				}

				.title0 {
					font-size: 26px;
					color: #999999;
					text-align: center;
					padding: 0 30px;
					cursor: pointer;

					&:hover {
						font-weight: bold;
					}

					&-active {
						color: #666666;
						font-weight: bold;
					}
				}

				.tab-line {
					width: 3px;
					height: 30px;
					background: #999999;
					border-radius: 10px;
				}
			}

			.img-line {
				width: 145px;
				object-fit: scale-down;
				margin-bottom: 10px;
			}

			.title {
				font-size: 48px;
				color: #000000;
				letter-spacing: 5px;
			}

			.subtitle {
				font-size: 24px;
				color: #666666;
			}

			.img-develop {
				width: 1000px;
				height: 590px;
				object-fit: cover;
			}

			.card-div {
				height: 650px;
				border-radius: 20px;
				overflow: hidden;
				cursor: pointer;

				.yellow-mask {
					background: RGBA(251, 225, 12, 0.8);

					.title1 {
						font-size: 50px;
						color: #000000;
					}

					.title2 {
						font-size: 25px;
						color: #000000;
					}
				}

				.show-div {
					.img2 {
						width: 100%;
						height: 442px;
						object-fit: cover;
					}

					.black1 {
						background-color: #000000;

						.title11 {
							font-size: 50px;
							color: #FFFFFF;
							margin-left: 60px;
							margin-top: 20px;
						}

						.title22 {
							font-size: 26px;
							color: #FFFFFF;
							line-height: 40px;
							margin-left: 60px;
							margin-top: 20px;
							font-weight: 300;
						}
					}
				}
			}

			.black-div {
				background: #000000;
				overflow: auto;
				margin-right: -250px;
				z-index: 100;

				.title-black {
					margin: 50px 50px 50px 60px;
					font-size: 24px;
					color: #FFFFFF;
					line-height: 45px;
					font-weight: 300;
				}
			}

			.item-card {
				box-shadow: 0px 10px 30px 0px rgba(40, 40, 40, 0.3);
				cursor: pointer;

				&:hover {
					background-color: #FADA0F;
				}

				.img-card {
					width: 100%;
					height: auto;
					object-fit: fill;
				}

				.title1 {
					font-size: 30px;
					color: #222222;
					font-weight: bold;
					margin: 40px 30px 20px 30px;
				}

				.title2 {
					font-size: 20px;
					color: #222222;
					margin: 0 30px;
				}

				.title3 {
					font-size: 20px;
					color: #222222;
					line-height: 30px;
					margin: 30px 30px 40px 30px;
				}
			}
		}

		.item-show {
			width: 844px;
			height: 150px;
			background: #F6F6F6;
			margin-right: 20px;
			margin-bottom: 20px;
			cursor: pointer;

			&:hover {
				background: #FFE100;

				.look-div {
					background-color: #000000;
					color: #FFFFFF;
				}
			}

			&:nth-child(2n) {
				margin-right: 0;
			}

			.title1 {
				font-size: 30px;
				color: #000000;
				font-weight: bold;
			}

			.title2 {
				font-size: 24px;
				color: #000000;
				margin-top: 10px;
			}

			.look-div {
				width: 90px;
				height: 36px;
				background: #FFE100;
				line-height: 36px;
				text-align: center;
				font-size: 24px;
				color: #000000;
				margin-top: 33px;
				margin-right: 33px;
			}
		}

		.item-video {
			width: 700px;
			height: 400px;
			margin-right: 15px;
			margin-bottom: 15px;

			&:nth-child(2n) {
				margin-right: 0;
			}

			.video {
				width: 100%;
				height: 100%;
			}
		}

		.img-more {
			width: 320px;
			height: 60px;
			object-fit: scale-down;
			margin-top: 80px;
			cursor: pointer;
		}

		.img-shop {
			width: 100%;
			background-color: lightblue;
			object-fit: fill;
		}

		.item-news {
			width: 100%;
			height: 250px;
			background: #FFFFFF;
			box-shadow: 0px 10px 30px 0px rgba(40, 40, 40, 0.1);
			cursor: pointer;
			margin-bottom: 40px;

			&:hover {
				background: #FADA0F;
			}

			.img-news {
				width: 396px;
				height: 100%;
				object-fit: cover;
			}

			.news-title {
				font-size: 30px;
				font-weight: bold;
				color: #222222;
			}

			.news-date {
				font-size: 24px;
				color: #222222;
			}

			.news-content {
				font-size: 20px;
				color: #222222;
				line-height: 36px;
			}
		}

		.map-div {
			width: 100%;
			height: 60vh;
		}
	}
</style>
